import { CopyIcon } from '@chakra-ui/icons';
import {
	Box,
	HStack,
	Heading,
	Icon,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Skeleton,
	Text,
	useClipboard,
	useColorMode,
	useToast,
} from '@chakra-ui/react';

import { ConfirmButton } from '@/components/ui';

const id = 'copy-toast';

type PasswordModalProps = {
	onClose: () => void;
	password?: string;
};

export const PasswordModal = ({ onClose, password }: PasswordModalProps) => {
	const { colorMode } = useColorMode();

	const { onCopy } = useClipboard(password as string);
	const toast = useToast();

	const onCopyClick = () => {
		onCopy();
		if (!toast.isActive(id)) {
			toast({
				title: `Copied`,
				id,
				position: 'top',
				isClosable: true,
				duration: 1000,
			});
		}
	};

	return (
		<Modal isOpen onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader textAlign="center">
					Your auto-generated Nellie Cal appointment manager password:
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Box
						bg={colorMode === 'light' ? 'gray.100' : 'gray.700'}
						border="dashed"
						borderColor={colorMode === 'light' ? 'gray.300' : 'gray.600'}
						borderRadius="xl"
						mx="auto"
						my="3"
						overflow="hidden"
						textAlign="center"
						width="250px"
					>
						<Skeleton
							_hover={{
								bg: colorMode === 'light' ? 'purple.50' : 'purple.700',
							}}
							as={Heading}
							cursor="pointer"
							isLoaded={Boolean(password)}
							py="2"
							onClick={onCopyClick}
						>
							{password || '???'}
						</Skeleton>
					</Box>
					<Box mb={6} w="full">
						<Box
							_hover={{
								bg: colorMode === 'light' ? 'purple.50' : 'purple.700',
								borderRadius: 'lg',
							}}
							cursor="pointer"
							mx="auto"
							pl={1}
							py={2}
							w="150px"
							onClick={onCopyClick}
						>
							<HStack mx="auto" spacing={0}>
								<Icon as={CopyIcon} width="25px" />
								<Text fontSize="sm" fontWeight="normal">
									copy to clipboard
								</Text>
							</HStack>
						</Box>
					</Box>
				</ModalBody>
				<ModalFooter>
					<ConfirmButton onClick={onClose}>Close</ConfirmButton>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
